import i18n from 'i18next';

import * as Yup from 'yup';

const quantityValidateSchema = Yup.object().shape({
    quantity: Yup.number().typeError(i18n.t("quantity_is_required_string")).required(i18n.t("quantity_is_required_string")).moreThan(0, i18n.t("quantity_cannot_be_zero_string"))
});
const priceValidateSchema = quantityValidateSchema.shape({
    price: Yup.number().typeError(i18n.t("price_is_required_string")).required(i18n.t("price_is_required_string")).moreThan(0, i18n.t("price_cannot_be_zero_string"))
});

const findState = (doc:any,state: string) => doc.states.find((s: any) => s.id === state);

export {quantityValidateSchema,priceValidateSchema,findState}